import { useEffect, useState } from 'react'
import { useTheme } from 'styled-components'
import { Breakpoint } from './breakpoints.types'
import { getBreakpoint } from './breakpoints'

function getWindowWidth(): number | undefined {
  if (typeof window !== 'undefined') {
    const { innerWidth: width } = window

    return width
  }

  return undefined
}

/** Current window width hook */
export function useWindowWidth(): number | undefined {
  const [windowWidth, setWindowWidth] = useState(getWindowWidth())

  useEffect(() => {
    function handleResize() {
      setWindowWidth(getWindowWidth())
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return windowWidth
}

/** If window smaller then breakpoint */
export function useBreakpointEnding(breakpoint: Breakpoint): boolean | undefined {
  function calculateResult(breakpointValue: number) {
    const windowWidth = getWindowWidth()

    return windowWidth ? windowWidth <= breakpointValue : undefined
  }

  const theme = useTheme()
  const value = getBreakpoint(breakpoint, theme.breakpoints)
  const [isSatisfied, setIsSatisfied] = useState<boolean | undefined>(calculateResult(value))

  useEffect(() => {
    function handleResize() {
      setIsSatisfied(calculateResult(value))
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [value, setIsSatisfied])

  return isSatisfied
}

/** If window bigger then breakpoint */
export function useBreakpointStarting(breakpoint: Breakpoint): boolean | undefined {
  function calculateResult(breakpointValue: number) {
    const windowWidth = getWindowWidth()

    return windowWidth ? windowWidth >= breakpointValue : undefined
  }

  const theme = useTheme()
  const value = getBreakpoint(breakpoint, theme.breakpoints)
  const [isSatisfied, setIsSatisfied] = useState<boolean | undefined>(calculateResult(value))

  useEffect(() => {
    function handleResize() {
      setIsSatisfied(calculateResult(value))
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [value, setIsSatisfied])

  return isSatisfied
}
